<template>
  <div class="workspace_wrap ">
    <!-- 第一部分 -->
    <div class="workspace1">
      <el-row>
        <p class="workspace-title">数据控制面板</p>
      </el-row>
      <el-row :gutter="30"  justify="center">
      <el-col :span="4">
        <el-card class="box-card workspace-card1">  
          <h3 v-if="count_data.activity_sum">{{count_data.activity_sum}}次</h3>
          <h3 v-else>0次</h3>
          <p>活动数</p>
          <i class="el-icon-time"></i>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="box-card workspace-card2">  
          <h3 v-if="count_data.buy_sum">{{count_data.buy_sum}}次</h3>
          <h3 v-else>0次</h3>
          <p>成交次数</p>
          <i class="el-icon-shopping-cart-2"></i>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="box-card workspace-card3">  
          <h3 v-if="count_data.click_sum">{{count_data.click_sum}}</h3>
          <h3 v-else>0</h3>
          <p>曝光量</p>
          <i class="el-icon-view"></i>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="box-card workspace-card4">  
          <h3 v-if="count_data.repost_sum">{{count_data.user_num}}人</h3>
          <h3 v-else>0人</h3>
          <p>用户数</p>
          <i class="el-icon-user"></i>
        </el-card>
      </el-col>
      <el-col :span="4">
        <el-card class="box-card workspace-card4">  
          <h3 v-if="count_data.repost_sum">{{count_data.repost_sum}}次</h3>
          <h3 v-else>0次</h3>
          <p>转发量</p>
          <i class="el-icon-share"></i>
        </el-card>
      </el-col>
    </el-row>
    </div>
    <!-- 第二部分 -->
    <div class="workspace2" v-if="summary.length>0">
      <template>
        <el-tabs v-model="workspace2ActiveName" type="card" >
          <el-tab-pane label="汇总" name="first" >
              <div class="workspace2-box">
                <div class="item">
                  <p>用户账户总额</p>
                  <p>{{summary[0].balance_total}} <span>元</span> </p>
                </div>
                <div class="item">
                  <p>活动累计佣金</p>
                  <p>{{summary[0].invitation_total}} <span>元</span></p>
                </div>
                <div class="item">
                  <p>活动累计订单</p>
                  <p>{{summary[0].order_num_total}} <span>单</span></p>
                </div>
                <div class="item">
                  <p>活动订单金额</p>
                  <p>{{summary[0].order_total}} <span>元</span></p>
                </div>
                <!-- <div class="item">
                  <p>账户累计充值</p>
                  <p>{{summary[0].recharge_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动微信支付</p>
                  <p>{{summary[0].wx_pay_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动累计提现</p>
                  <p>{{summary[0].withdraw_total}} <span>元</span></p>
                </div> -->
              </div>
          </el-tab-pane>
          <el-tab-pane label="今日" name="second">
              <div class="workspace2-box">
                <div class="item">
                  <p>用户账户总额</p>
                  <p>{{summary[1].balance_total}} <span>元</span></p>
                </div>
                <div class="item">
                  <p>活动累计佣金</p>
                  <p>{{summary[1].invitation_total}} <span>元</span></p>
                </div>
                <div class="item">
                  <p>活动累计订单</p>
                  <p>{{summary[1].order_num_total}} <span>单</span></p>
                </div>
                <div class="item">
                  <p>活动订单金额</p>
                  <p>{{summary[1].order_total}} <span>元</span></p>
                </div>
                <!-- <div class="item">
                  <p>账户累计充值</p>
                  <p>{{summary[1].recharge_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动微信支付</p>
                  <p>{{summary[1].wx_pay_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动累计提现</p>
                  <p>{{summary[1].withdraw_total}} <span>元</span></p>
                </div> -->
              </div>
          </el-tab-pane>
          <el-tab-pane label="7日" name="third">
              <div class="workspace2-box">
                <div class="item">
                  <p>用户账户总额</p>
                  <p>{{summary[2].balance_total}} <span>元</span></p>
                </div>
                <div class="item">
                  <p>活动累计佣金</p>
                  <p>{{summary[2].invitation_total}} <span>元</span></p>
                </div>
                <div class="item">
                  <p>活动累计订单</p>
                  <p>{{summary[2].order_num_total}} <span>单</span></p>
                </div>
                <div class="item">
                  <p>活动订单金额</p>
                  <p>{{summary[2].order_total}} <span>元</span></p>
                </div>
                <!-- <div class="item">
                  <p>账户累计充值</p>
                  <p>{{summary[2].recharge_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动微信支付</p>
                  <p>{{summary[2].wx_pay_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动累计提现</p>
                  <p>{{summary[2].withdraw_total}} <span>元</span></p>
                </div> -->
              </div>
          </el-tab-pane>
          <el-tab-pane label="30日" name="fourth">
              <div class="workspace2-box">
                <div class="item">
                  <p>用户账户总额</p>
                  <p>{{summary[3].balance_total}} <span>元</span></p>
                </div>
                <div class="item">
                  <p>活动累计佣金</p>
                  <p>{{summary[3].invitation_total}} <span>元</span></p>
                </div>
                <div class="item">
                  <p>活动累计订单</p>
                  <p>{{summary[3].order_num_total}} <span>单</span></p>
                </div>
                <div class="item">
                  <p>活动订单金额</p>
                  <p>{{summary[3].order_total}} <span>元</span></p>
                </div>
                <!-- <div class="item">
                  <p>账户累计充值</p>
                  <p>{{summary[3].recharge_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动微信支付</p>
                  <p>{{summary[3].wx_pay_total}} <span>元</span></p>
                </div> -->
                <!-- <div class="item">
                  <p>活动累计提现</p>
                  <p>{{summary[3].withdraw_total}} <span>元</span></p>
                </div> -->
              </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
    <!-- 第三部分 -->
    <div class="workspace3">
      <el-row :gutter="20">
        <!-- 第三部分右边 -->
        <el-col :span="24" class="col_height">
          <div class="whitebg col_height">
            <template>
              <el-tabs v-model="workspace3ActiveName" type="card" >
                <!-- <el-tab-pane label="新进会员" name="first">新进会员</el-tab-pane> -->
                <el-tab-pane label="活动列表" name="first">
                    <template v-if="activityList.length !=0">
                      <el-table 
                        height="360"
                        :data="activityList"
                        style="width: 100%"
                        :row-class-name="tableRowClassName">
                        <el-table-column
                          prop="title"
                          label="活动名称"
                          width="180">
                          <div slot-scope="scope">
                            <span :title="scope.row.title ">{{scope.row.title | ellipsis}}</span>
                          </div>
                        </el-table-column>
                        <el-table-column
                          prop="template_type"
                          label="活动类型"
                          width="180">
                        </el-table-column>
                        <el-table-column
                          prop="join_num"
                          label="参与人数">
                        </el-table-column>
                        <el-table-column
                          prop="buy_num"
                          label="购买人数">
                        </el-table-column>
                        <el-table-column
                          prop="click_num"
                          label="点击量">
                        </el-table-column>
                        <el-table-column
                          prop="repost_num"
                          label="转发量">
                        </el-table-column>
                        <el-table-column
                          prop="status_text"
                          label="活动状态">
                        </el-table-column>
                      </el-table>
                    </template>
                    <template v-else>
                      <div class="nothingInfo">活动列表暂无信息</div>
                    </template>
                </el-tab-pane>
                <!-- <el-tab-pane label="提现列表" name="second">
                  <template v-if="withdrawRecordDataList.length !=0">
                      <el-table
                        height="360"
                        :data="withdrawRecordDataList"
                        style="width: 100%"
                        :row-class-name="tableRowClassName">
                        <el-table-column
                          prop="avatar"
                          label="头像"
                          width="90">
                          <template slot-scope="scope">
                            <img :src="scope.row.avatar || 'static/img/userDefult.png'" alt width="30px" height="30px"/>
                          </template>
                     
                        </el-table-column>
                        <el-table-column
                          prop="nickname"
                          label="昵称"
                          width="180">
                        </el-table-column>
                        <el-table-column
                          prop="amount"
                          label="提现金额">
                        </el-table-column>
                        <el-table-column
                          prop="withdraw_method"
                          label="提现方式">
                        </el-table-column>
                        <el-table-column
                          prop="create_time"
                          label="创建时间">
                        </el-table-column>
                        <el-table-column
                          prop="status_text"
                          label="处理状态">
                        </el-table-column>
                      </el-table>
                  </template>
                  <template v-else>
                      <div class="nothingInfo">提现列表暂无信息</div>
                  </template>
                </el-tab-pane> -->
                
                <!-- <el-tab-pane label="充值列表" name="third">
                  <template v-if="investMoneyDataList.length != 0">
                      <el-table
                        height="360"
                        :data="investMoneyDataList"
                        style="width: 100%"
                        :row-class-name="tableRowClassName">
                        <el-table-column
                          prop="title"
                          label="标题"
                          width="220">
                        </el-table-column>
                        <el-table-column
                          prop="price"
                          label="金额"
                          width="120">
                        </el-table-column>
                        <el-table-column
                          prop="order_no"
                          label="订单号"
                          width="280">
                        </el-table-column>
                        <el-table-column
                          prop="create_time"
                          label="充值时间"
                          width="160">
                        </el-table-column>
                        <el-table-column
                          prop="pay_text"
                          label="状态">
                        </el-table-column>
                      </el-table>
                  </template>
                  <template v-else>
                      <div class="nothingInfo">充值列表暂无信息</div>
                  </template>
                </el-tab-pane> -->
                <!-- <el-tab-pane label="用户提现" name="fourth">用户提现</el-tab-pane>
                <el-tab-pane label="红包补发" name="five">红包补发</el-tab-pane> -->
              </el-tabs>
            </template>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 第四部分 -->
    <div class="workspace4">
      <template>
        <el-tabs v-model="workspace4ActiveName" type="card" >
          <el-tab-pane label="用户增长" name="first">
            <div class="Echarts">
              <div id="main1" style="width:1000px;height:400px;"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="活动趋势" name="second">
            <div class="Echarts">
              <div id="main2" style="width: 1000px;height:400px;"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资金趋势" name="third">
            <div class="Echarts">
              <div id="main3" style="width:1000px;height:400px;"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="订单趋势" name="fourth">
            <div class="Echarts">
              <div id="main4" style="width:1000px;height:400px;"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";
  import {yeartime, yearDatetime} from '@/assets/js/common';
  var $echarts = require("echarts");
  export default {
    name: "tkWorkSpace",
    filters: {  // 限制文本显示字数,超出部分用...代替
      ellipsis (value) {
          if (!value) return ''
          if (value.length > 25) {
            return value.slice(0,25) + '...'
          }
          return value
      },
    },  
    data() {
      return {
        orgOptions: {},
        bodywidth:0,
        account_info:{},
        count_data:{},
        summary:[],
        activityList: [{
          title: '',
          template_type: '',
          join_num: '',
          buy_num:'',
          click_num:'',
          repost_num:'',
          status_text:''
        }],
        withdrawRecordDataList: [{
          avatar: '',
          nickname: '',
          amount:'',
          withdraw_method: '',
          create_time:'',
          status_text:'',
        }],
        investMoneyDataList: [{
          title:'',
          price:'',
          order_no:'',
          create_time:'',
          pay_status:'',
          pay_text:''
        }],
        homeTrendData1:'',
        homeTrendData2:'',
        homeTrendData3:'',
        homeTrendData4:'',
        XArry1:'',
        YArry1:'',
        workspace2ActiveName: 'first',
        workspace3ActiveName:'first',
        workspace4ActiveName:'first',
        // isChildUpdate1:true,
        // isChildUpdate2:false,
        // isChildUpdate3:false,
        // isChildUpdate4:false,
      };
    },
    created() {
      this.bodywidth = (document.body.clientWidth-240)+'px'
      this.getHomePageInfoData();//获取概括信息
      this.getactivityListData();//获取活动列表信息
      // this.getWithdrawRecordData();//获取提现列表信息
      // this.getInvestMoneyDataList();//获取充值列表信息
      this.getHomeTrendData(1);
      this.getHomeTrendData(2);
      this.getHomeTrendData(3);
      this.getHomeTrendData(4);
    },
    
    methods:{
      //获取后台主页信息
      getHomePageInfoData(){
        this.axios.post(api.homePage,{})
          .then(res =>{
            if(res.data.code == 0){
              this.account_info = res.data.result.account_info;
              this.count_data = res.data.result.count_data;
              this.summary =res.data.result.summary;
            }
          }).catch(() => {})
      },
      //获取活动列表
      getactivityListData(){
        this.axios.post(api.activityIndex,{page:1})
          .then(res =>{
            if(res.data.code == 0){
              this.activityList = res.data.result.list;
            }
          })
      },
      //获取提现列表
      getWithdrawRecordData(){
        this.axios.post(api.withdrawalRecord,{page:1})
          .then(res =>{
            if(res.data.code == 0){
              this.withdrawRecordDataList = res.data.result
            }
          }).catch(() => {})
      },
      //获取充值列表
      getInvestMoneyDataList(){
        this.axios.post(api.rechargeList,{page:1})
          .then(res =>{
            if(res.data.code == 0){
              this.investMoneyDataList = res.data.result;
              if(this.investMoneyDataList){
                this.investMoneyDataList.forEach((item,index) => {
                  if (item.pay_status == 0) {
                    this.investMoneyDataList[index].pay_text ='未支付'
                  } else {
                    this.investMoneyDataList[index].pay_text ='已支付'
                  }
                })
              }
            }
          }).catch(() => {})
      },
      //头像值为空
      errorHandler() {
        return true
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
          return 'warning-row';
        } else if (rowIndex === 3) {
          return 'success-row';
        }
        return '';
      },
      //获取后台主页趋势图数据
      getHomeTrendData(val){ 
        this.axios.post(api.homeTrend,{
          type:val
        })
        .then(res =>{
          if(res.data.code == 0){
            if(val == 1){
              this.homeTrendData1 = res.data.result.data;
            }
            if(val == 2){
              this.homeTrendData2 = res.data.result.data;
            }
            if(val == 3){
              this.homeTrendData3 = res.data.result.data;
            }
            if(val == 4){
              this.homeTrendData4 = res.data.result.data;
            }
          }
        }).catch(() => {})
      },
      myEcharts(val,homeTrendData){
        let textTitle='';
        let textUnit = '';
        let homeTrendDatas=[];
        let xdata=[];
        let ydata=[];
        homeTrendDatas = homeTrendData
        if(homeTrendDatas){
          homeTrendDatas.forEach((item,i) =>{
            xdata.push(item.create_time)
            ydata.push(item.number)
          })
        }
        // 基于准备好的dom，初始化echarts实例
        var myChart = $echarts.init(document.getElementById('main'+val));
        if(val == 1){
          textTitle = '用户增长图'
          textUnit = '数量/个'
        }
        if(val == 2){
          textTitle = '活动趋势图'
           textUnit = '数量/个'
        }
        if(val == 3){
          textTitle = '资金趋势图'
           textUnit = '数量/元'
        }
        if(val == 4){
          textTitle = '订单趋势图'
           textUnit = '数量/单'
        }
          
        // 指定图表的配置项和数据
        var option = {
          color: ['#00c0ef'],
          title: {
            text: textTitle
          },
          tooltip: {},
          legend: {
            data:[textUnit]
          },
          xAxis: {
            data: xdata
          },
          yAxis: {},
          series: [{
            name: textUnit,
            type: 'bar',
            data: ydata
          }]
        };

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      }
   
   
    },
    mounted() {
     this.myEcharts(1);
     this.myEcharts(2);
     this.myEcharts(3);
     this.myEcharts(4);
    },
    watch:{
      homeTrendData1: {
        handler(val) {
          if (val) {
            this.$nextTick(function(){
                this.myEcharts(1,this.homeTrendData1);
              })
          }
        }
      },
      homeTrendData2: {
        handler(val) {
          if (val) {
            this.$nextTick(function(){
                this.myEcharts(2,this.homeTrendData2);
              })
          }
        }
      },
      homeTrendData3: {
        handler(val) {
          if (val) {
            this.$nextTick(function(){
                this.myEcharts(3,this.homeTrendData3);
              })
          }
        }
      },
      homeTrendData4: {
        handler(val) {
          if (val) {
            this.$nextTick(function(){
                this.myEcharts(4,this.homeTrendData4);
              })
          }
        }
      }
    }
  };
</script>
<style scoped>

.el-switch.is-disabled .el-switch__core,
.el-switch.is-disabled .el-switch__label {
  cursor: pointer;
}
</style>
